import { IReqCompra } from './../models/IReqCompra.model';
import { ROUTE_LOGISTICA } from './../constants/constant.model';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class ReqCompraService {


    constructor(private apiService: ApiService,
        private http: HttpClient) { }

    insertarReqCompra(data: IReqCompra): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_LOGISTICA.crudReqCompra);
        return this.apiService.executePostJson(data).pipe();
    }

    actualizarReqCompra(data: IReqCompra): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_LOGISTICA.crudReqCompra);
        return this.apiService.executePutJson(data).pipe();
      }

    calcularReqCompra(data: IReqCompra): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_LOGISTICA.calcularReqCompra);
        return this.apiService.executePutJson(data).pipe();
    }

    buscarReqCompra(fdesde: string, fhasta: string, codcli: string, codven: number, codsuc: number, situac: string, lugemi: number, limit: number, offset: number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_LOGISTICA.buscarReqCompra);
        return this.apiService.execGetQueryJson(`?fdesde=${fdesde}&fhasta=${fhasta}&codcli=${codcli}&codven=${codven}&codsuc=${codsuc}&situac=${situac}&lugemi=${lugemi}&limit=${limit}&offset=${offset}`).pipe();
    }

    download_pdf(_formato: number, numint: number, cia: string) {
        let fullUrl: any = null;
        if (_formato == 1)
            fullUrl = environment.serviceUrl_Report + `requerimiento-compra/${numint}/report/public/format-1.pdf?` + "cia=" + cia;
        if (_formato == 2)
            fullUrl = environment.serviceUrl_Report + `requerimiento-compra/${numint}/report/public/format-2.pdf?` + "cia=" + cia;
        const httpOptions = {
            'responseType': 'arraybuffer' as 'json'
        };
        return this.http.get(fullUrl, httpOptions);
    }

    reutilizarReqCompra(serie: number, numdoc: number) {
        this.apiService.setUrlPathApi(ROUTE_LOGISTICA.crudReqCompra);
        return this.apiService.execGetQueryJson(`/${serie}/${numdoc}`).pipe();
    }

    visarReqCompra(numint:number , coduser:string ): Observable<any> {
     return this.http.put(environment.serviceUrl+ROUTE_LOGISTICA.crudReqCompra+`/${numint}/visar?coduser=${coduser}`,{observe : "response"})
    }

    visarReqComprav2(numint:number , coduser:string ): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_LOGISTICA.crudReqCompra+`/${numint}/visar?coduser=${coduser}`);
        return this.apiService.executePutJson("").pipe();
    }
    
    anularReqCompra(numint:number , coduser:string ): Observable<any> {
        return this.http.put(environment.serviceUrl+ROUTE_LOGISTICA.crudReqCompra+`/${numint}/anular?coduser=${coduser}`,{observe : "response"})
       }


    obtenerReqCompra(numint : number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTE_LOGISTICA.crudReqCompra);
        return this.apiService.execGetQueryJson(`/${numint}`).pipe();
    }

    getListDetallesPendientes(numints: string) {
        this.apiService.setUrlPathApi('documento-generico/detalle-pendiente?');
        return this.apiService.execGetQueryJson(`numints=${numints}`);
        //return this.http.get(`${this.clienteService.getUrlSession().urlService}/documento-generico/detalle-pendiente?numints=${numints}`, { observe: 'response' });
      }

      downloadExcelComercialResportesRequeCompra(fdesde: string, fhasta: string, codcli: string, codven: number, codsuc: number, situac: string, lugemi: number, limit: number, offset: number): Observable<any> {
        this.apiService.setUrlPathApi('consultas/reque-compra');
        return this.apiService.execGetQueryJsonPDF(`/excel.xlsx?fdesde=${fdesde}&fhasta=${fhasta}&codcli=${codcli}&codven=${codven}&codsuc=${codsuc}&situac=${situac}&lugemi=${lugemi}&limit=${limit}&offset=${offset}`).pipe();
      }
    
}
